/*  Shared  */
import { runReportLinkURL } from 'application/Home/Reports/helpers';
import { ReportParams } from 'application/Shared/types/reports';

/*  React  */
import React from 'react';
import { Link, useParams } from 'react-router';

/**
 * A component that creates a link to run a report with specified parameters
 *
 * @param {object} props - Component props
 * @param {React.ReactNode} props.children - Child elements to render inside the link
 * @param {string} [props.data-trackid] - Optional tracking ID for analytics, defaults to 'reports_runReportLink_routeTo'
 * @param {ReportParams} props.reportParams - Parameters to pass to the report
 * @returns {JSX.Element} Link component that navigates to report with params
 */
export const RunReportLink = ({
    children,
    'data-trackid': dataTrackid = 'reports_runReportLink_routeTo',
    reportParams
}: {
    children: React.ReactNode;
    'data-trackid'?: string;
    reportParams: Partial<ReportParams>;
}) => {
    const { clientId, partnerId } = useParams();
    const url = runReportLinkURL({
        clientId,
        partnerId,
        reportParams
    });

    return (
        <Link
            className="link"
            to={url}
            data-testid="runReportLink"
            data-trackid={dataTrackid}
        >
            {children}
        </Link>
    );
};
